// In order to track pageview events inside out react app, we decided to go for the redux-beacon
// as it gives us more flexibility for the future. Implementing a middleware or a global reduce
// by ourselves would have been another option.
// For this part we got inspired by the following sites:
// * https://github.com/rangle/redux-beacon/blob/master/docs/examples-and-recipes.md

import { LOCATION_CHANGE } from "react-router-redux";
import { createMiddleware } from "redux-beacon";
import GoogleTagManager from "@redux-beacon/google-tag-manager";

// searches for key "gtm.start" in the dataLayer array
// this key is only set if google analytics was included
const isGaEnabled = () => {
  const dataLayerOrEmpty = window.dataLayer || [];

  return dataLayerOrEmpty.some(dataItem => {
    const gaDataItemKeys = Object.keys(dataItem);

    return gaDataItemKeys.includes("gtm.start");
  });
};

const createEmptyMiddleware = () => {
  return () => next => action => next(action);
};

const createGoogleTagManagerMiddleware = () => {
  const gtm = GoogleTagManager();

  const pageViewEventDefinition = () => {
    return {
      event: "customPageView",
      location: window.location.href,
    };
  };

  const eventsMap = {
    [LOCATION_CHANGE]: pageViewEventDefinition,
  };

  return createMiddleware(eventsMap, gtm);
};

const googleTagManagerMiddleware = isGaEnabled()
  ? createGoogleTagManagerMiddleware()
  : createEmptyMiddleware();

export default googleTagManagerMiddleware;
